import { PRODUCT_NAME } from "@amtana/i18n/catalog";

import type { ComparisonWords } from "./comparison-page.ts";
import { CHECKED_ON, SOURCES } from "./comparison-sources.ts";

// /es/compare/instagram-email-extractors, in Spanish. It names approaches only (ADR-034 point 4),
// and the product's row claims only what it reads: followers and following (D1151).
const USE_CASE = "/use-cases/competitor-followers";

export const INSTAGRAM_EMAIL_EXTRACTORS_WORDS_ES: ComparisonWords = {
  linkLabel: "Extractores de email",
  title: "Extractores de email de Instagram, comparados",
  description:
    "Extractores de email de Instagram comparados por enfoque: extensiones de navegador, brókers de listas y scrapers genéricos, sus fortalezas y qué revisar.",
  keyphrase: "extractores de email de instagram",
  heroTitle: "Extractores de email de Instagram: cuatro enfoques comparados",
  lede: "Elige según el trabajo. Cada enfoque sirve para algo distinto, así que aquí tienes dónde destaca cada uno y qué revisar primero.",
  tableLabel: "Cuatro enfoques para encontrar contactos en Instagram",
  rows: [
    {
      approach: "Extensión de navegador",
      strong: {
        text: "Funciona en tu propio navegador y lee las páginas que abres.",
        source: { label: "Chrome for Developers", href: SOURCES.contentScripts },
        checkedOn: CHECKED_ON,
      },
      check: {
        text: "Qué datos de los sitios pide leer, y en cuántos sitios.",
        source: { label: "Ayuda de Chrome Web Store", href: SOURCES.extensionPermissions },
        checkedOn: CHECKED_ON,
      },
      useCase: USE_CASE,
    },
    {
      approach: "Bróker de listas",
      strong: {
        text: "Empiezas con una lista que otro ya reunió.",
        source: { label: "ICO, el regulador del Reino Unido", href: SOURCES.boughtInLists },
        checkedOn: CHECKED_ON,
      },
      check: {
        text: "Si las personas de la lista aceptaron recibir tu marketing, por ese canal.",
        source: { label: "ICO, el regulador del Reino Unido", href: SOURCES.boughtInLists },
        checkedOn: CHECKED_ON,
      },
      useCase: USE_CASE,
    },
    {
      approach: "Scraper genérico",
      strong: {
        text: "Un programa que recorre páginas y recoge sus datos, así que tú eliges las páginas.",
        source: { label: "MDN Web Docs", href: SOURCES.crawler },
        checkedOn: CHECKED_ON,
      },
      check: {
        text: "Quién lo arregla cuando una página cambia, porque el código atado a su estructura puede fallar.",
        source: { label: "Documentación de Playwright", href: SOURCES.markupChanges },
        checkedOn: CHECKED_ON,
      },
      useCase: USE_CASE,
    },
  ],
  own: {
    approach: "Leer una audiencia",
    byline: PRODUCT_NAME,
    strong: "Los seguidores o las cuentas seguidas de una cuenta que eliges.",
    check:
      "Solo seguidores y cuentas seguidas de Instagram. Las cuentas privadas no se leen, y no todo perfil público muestra un contacto.",
    useCase: USE_CASE,
  },
  questions: [
    {
      question: "¿Qué enfoque sirve para una lista corta?",
      answer:
        "Uno que parte de una audiencia que tus compradores ya siguen. Es nuestra opinión, no una medición.",
    },
    {
      question: `¿Qué lee ${PRODUCT_NAME}?`,
      answer: "Los seguidores de una cuenta de Instagram o las cuentas que sigue, y solo perfiles públicos.",
    },
    {
      question: "¿Qué compra un crédito?",
      answer: "1 crédito lee 1 perfil público, con o sin contacto. Las cuentas privadas no se leen.",
    },
    {
      question: "¿Un contacto público significa que puedo enviarle marketing?",
      answer:
        "No. Un contacto público no es un consentimiento, así que revisa primero las normas de marketing que te aplican.",
    },
  ],
  ctaTitle: "Pruébalo con una cuenta",
  ctaDescription: "Tu primer análisis corre con créditos gratis.",
};
